var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard"}},[_c('Navigation',{staticClass:"nav"}),_c('Header',{attrs:{"title":_vm.title},on:{"handleNavigation":_vm.openNavigation}}),_c('div',{staticClass:"dashboard--content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }